<template>
<div class="chapter">
<div class="inner_page">
<h1 class="P_Heading_1" id="auto_bookmark_toc_1"><span>The Gentle Dom</span></h1>
<p class="P_Normal"> </p>
<p class="P_Norm-NoIndent">By Sean Michael</p>
<p class="P_Norm-NoIndent">An Iron Eagle Gym Novel</p>
<p class="P_Normal"> </p>
<p class="P_Normal">When one of their own is threatened, the men of the Iron Eagle Gym will stand together and prove they are stronger as a family.</p>
<p class="P_Normal">Stuntman Barclay Drambor suspects his fall from a roof was no accident. He believes his abusive ex was responsible, but he can’t prove it. Fortunately, a year has gone by with no word from Duncan, letting Barclay move on with his life—and that means dealing with the aftermath of his injuries. He finds personal trainer Reece “Rec” Gordon through a member of the gym, and it’s not long before their workouts together become much more intimate. Rec is gentle and goes out of his way to make Barclay comfortable, and in no time there’s talk of moving in together….</p>
<p class="P_Normal">But just as Barclay is healing and finding a place to belong, Duncan returns to destroy his happiness. Though Duncan will learn he’s messing with the wrong group of men, in the end, Barclay must face him. Will Rec’s love and the friendship of the others at the gym give him the confidence to stand up for himself?</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0002.vue?136a6098